module.exports = __webpack_public_path__ + "static/media/Rionegro.3abe3864.svg";